module.exports = __webpack_public_path__ + "static/image3-1f26b1a7528196c8e44e5d70e03f8651.jpg";